import { Iconstant } from '../../store-modules/app/ecb.constant';

export class productInfoHeaderController {
  editPriceUrl;
  editProductUrl;
  product: any;
  constructor(
    private $mPath,
    private $user,
    private MyConstant: Iconstant,
    private $state,
    private $mdDialog
  ) {
    'ngInject';
  }

  makeUrl(product) {
    this.$mPath.get().then(response => {
      this.$user.getInfo().then(user => {
        if (this.MyConstant.Type == 'bazaryab') {
          this.editPriceUrl = `${response.StoreVendorAdmin}/UserId/${
            user.data.UserID
          }/manageProduct/ProductID/${product.ProductID}`;
          this.editProductUrl = `${response.StoreVendorAdmin}/UserId/${
            user.data.UserID
          }/selectProduct/ProductID/${product.ProductID}`;
        } else {
          this.editPriceUrl = `${response.StoreAdmin}/UserId/${
            user.data.UserID
          }/manageProduct/ProductID/${product.ProductID}`;
          this.editProductUrl = `${response.StoreAdmin}/UserId/${
            user.data.UserID
          }/selectProduct/ProductID/${product.ProductID}`;
        }
      });
    });
  }

  editProduct() {
    var module_template_path = `${this.MyConstant.TemplateUrl}management/`;
    var node = { ID: this.product.ProductID };
    var dialog = this.$mdDialog.show({
      controller: [
        '$scope',
        '$mdDialog',
        '$rootScope',
        '$Manufacturer',
        '$Product',
        '$mdSidenav',
        '$uibModal',
        '$document',
        '$mdToast',
        '$timeout',
        function(
          $scope,
          $mdDialog,
          $rootScope,
          $Manufacturer,
          $Product,
          $mdSidenav,
          $uibModal,
          $document,
          $mdToast,
          $timeout
        ) {
          $scope.Label = $rootScope.Label;
          var imageItemLength = 0;
          $scope.isSelected = () => {
            return item => {
              return item.IsSelected;
            };
          };
          $scope.uploadSuccess = (Manufacturer, $file, $message, $flow) => {
            $scope.uploadProgrress = false;
            $scope.Product.UploadedImages = $scope.Product.UploadedImages || [];
            $scope.Product.UploadedImages.push({
              ImageUrl: $message.replace(/['"]+/g, ''),
              IsDefault:
                $scope.Product.UploadedImages.length == 0 ? true : false,
              ImageTitle: $file.name.substr(0, $file.name.lastIndexOf('.'))
            });
          };

          $scope.uploadError = ($file, $message, $flow) => {
            $scope.uploadProgrress = false;
            $scope.uploadErrorMessage = $message.replace(/['"]+/g, '');
          };
          $scope.editAttr = attributeDefine => {
            console.log(attributeDefine);
          };
          $scope.uploadImage = ($flow, $file) => {
            if ($flow.files[$flow.files.length - 1].size > 5000 * 1024) {
              $scope.uploadErrorMessage = 'حجم عکس نباید بیشتر از 5MB باشد.';
              $flow.files.splice($flow.files.length - 1, 1);
            } else {
              $scope.Product.UploadedImages =
                $scope.Product.UploadedImages || [];

              $scope.uploadErrorMessage = null;
              if (
                $flow.files.length + imageItemLength >
                $scope.Product.UploadedImages.length
              ) {
                $scope.uploadProgrress = true;

                $flow.upload();
              } else {
                $scope.uploadErrorMessage = 'این عکس موجود است';
                $timeout(() => {
                  $scope.uploadErrorMessage = null;
                }, 1500);
              }
            }
          };

          $scope.Manufacturer = new $Manufacturer();
          $scope.Product = new $Product();
          $scope.selectProductType = ProductType => {
            $scope.Product.ProductTypeID = ProductType.ID;
            $scope.SelectedProductTypeName = ProductType.Name;
            $Product.GetManufacturer(
              { ProductTypeID: ProductType.ID },
              data => {
                $scope.ManufacturerList = data;
              }
            );
            $scope.SelectedManufacturerName = null;
            $scope.Product.ManufacturerID = null;
          };
          $scope.SelectManufacturer = item => {
            $scope.SelectedManufacturerName = item.Name;
            $scope.Product.ManufacturerID = item.ManufacturerID;
          };

          enum E_ProductNatureType {
            General = 1,
            Service = 2,
            Downloadable = 3,
            Advertisement = 4,
            CreateWebsite = 5
          }
          $scope.ProductNatureTypeList = [
            { key: E_ProductNatureType.General, val: 'کالا' },
            { key: E_ProductNatureType.Service, val: 'خدمات' },
            { key: E_ProductNatureType.Downloadable, val: 'فایل قابل دانلود' },
            { key: E_ProductNatureType.Advertisement, val: 'تبلیغات' },
            { key: E_ProductNatureType.CreateWebsite, val: 'وب سایت' }
          ];

          // for attr

          $scope.OnInitImage = (Image, index) => {
            if (Image.IsDefault) {
              $scope.DefualtImage = index;
            }
          };
          $scope.setDefultImage = defaultImage => {
            angular.forEach($scope.Product.UploadedImages, (val, key) => {
              val.IsDefault = false;
              if (defaultImage == key) {
                val.IsDefault = true;
                $scope.Product.ImageFullPath = val.ImageUrl;
              }
            });
          };
          $scope.removeImage = ($index, Image) => {
            var modalInstance = $uibModal.open({
              animation: true,
              templateUrl: `${module_template_path}confirmDialog.html?cdv=${cdv}`,
              controller: [
                '$scope',
                'confirm',
                '$uibModalInstance',
                function($scope, confirm, $uibModalInstance) {
                  $scope.confirm = confirm;
                  $scope.accept = function() {
                    $uibModalInstance.close();
                  };
                  $scope.abort = function() {
                    $uibModalInstance.dismiss();
                  };
                }
              ],
              resolve: {
                confirm: {
                  title: 'آیا از حذف این مورد اطمینان دارد؟',
                  textContent: `در صورت تایید این عکس حذف خواهد شد.`,
                  ok: 'بله حذف کن!',
                  cancel: 'منصرف شدم'
                }
              },
              appendTo: $document.find('.md-dialog-container'),
              size: 'xs'
            });

            modalInstance.result.then(function(selectedItem) {
              $Product.removeImage(
                { ProductID: node.ID, sequenceID: Image.SequenceID },
                function(data) {
                  $scope.Product.UploadedImages.splice($index, 1);
                }
              );
            });
          };
          if (node) {
            $scope.AjaxLoading = true;
            $scope.loadAttr = () => {
              if (!$scope.AttrList) {
                $scope.attrLoading = true;
                $Product.getAllAttr({ ProductID: node.ID }, data => {
                  $scope.attrLoading = false;
                  $scope.AttrList = data;
                });
              }
            };
            $Product.get({ ProductID: node.ID }, data => {
              if (data.SEO_tags) {
                data.SEO_tags = data.SEO_tags.split(',');
              }
              $scope.Product = data;
              $scope.Product.ExistProduct = true;
              imageItemLength = $scope.Product.UploadedImages.length;
              $scope.AjaxLoading = false;
              $scope.SelectedManufacturerName = data.ManufacturerName;
              $scope.Product.ManufacturerID = data.ManufacturerID;
              $scope.Product.ProductTypeID = data.ProductTypeID;
              $Product.GetManufacturer(
                { ProductTypeID: data.ProductTypeID },
                (ManufacturerList: any) => {
                  $scope.ManufacturerList = ManufacturerList;
                }
              );
              // $Manufacturer.getAllParent((data2) => {
              //     $scope.AllProductType = data2;
              //     $Product.GetManufacturer({ ProductTypeID: data.ProductTypeID }, (data) => {
              //         $scope.ManufacturerList = data
              //     })
              // });
            });
          } else {
            $Manufacturer.getAllParent(data => {
              $scope.AllProductType = data;
            });
          }
          $scope.onInitProductType = (ProductType, Product) => {
            if (ProductType.ProductTypeID == Product.ProductTypeID) {
              $scope.SelectedProductTypeName = ProductType.ProductTypeName;
            }
          };
          $scope.onInitManufacturer = (Manufacturer, Product) => {
            if (Manufacturer.ManufacturerID == Product.ManufacturerID) {
              $scope.SelectedManufacturerName = Manufacturer.Name;
            }
          };
          $scope.toggleLeft = buildToggler('left');

          function buildToggler(componentId) {
            return function() {
              $mdSidenav(componentId).toggle();
            };
          }

          $scope.sliderOptions = AttributeDefine => {
            AttributeDefine.ProductAttributeValue_AcceptableValueList[0].Value =
              AttributeDefine.ProductAttributeValue_AcceptableValueList[0]
                .Value || AttributeDefine.ScalarValFrom;
            var options = {
              floor: AttributeDefine.ScalarValFrom,
              ceil: AttributeDefine.ScalarValTo,
              showSelectionBar: true,
              onEnd: () => {
                AttributeDefine.ProductAttributeValue_AcceptableValueList[0].IsSelected = true;
              }
            };
            return options;
          };
          $scope.changeRadioModel = AttributeDefine => {
            angular.forEach(
              AttributeDefine.ProductAttributeValue_AcceptableValueList,
              (val, key) => {
                val.IsSelected = false;
                if (val.Value == AttributeDefine.Model) {
                  val.IsSelected = true;
                }
              }
            );
          };
          $scope.$watch('Product.ManufacturerID', ManufacturerID => {
            if (ManufacturerID && !node) {
              $scope.Product.ChangeParent = true;
            }
          });
          $scope.saveProduct = (Product, ExitAfterSave) => {
            var SEO_tags = '';
            angular.forEach($scope.Product.SEO_tags, (val, key) => {
              SEO_tags = SEO_tags + val;
              if (key !== $scope.Product.SEO_tags.length - 1) {
                SEO_tags = SEO_tags + ',';
              }
            });
            $scope.Product.SEO_tags = SEO_tags;
            if (ExitAfterSave) {
              $scope.Product.$save(data => {
                $mdDialog.hide();
              });
            } else {
              $scope.AjaxLoading = true;
              $scope.Product.$save(data => {
                Product.ProductID = data.ProductID;
                $Product.get({ ProductID: data.ProductID }, data => {
                  $scope.Product = data;
                  $scope.Product.ExistProduct = true;
                  $scope.Product.IsChange = true;
                  imageItemLength = $scope.Product.UploadedImages.length;
                  $scope.AjaxLoading = false;
                  $Product.GetManufacturer(
                    { ProductTypeID: data.ProductTypeID },
                    data => {
                      $scope.ManufacturerList = data;
                    }
                  );
                });
                $mdToast.show(
                  $mdToast
                    .simple()
                    .position('top right')
                    .textContent('تغییرات با موفقیت ذخیره شد.')
                    .hideDelay(3000)
                    .parent($document.find('.md-dialog-container'))
                );

                $Product.getAllAttr({ ProductID: data.ProductID }, data => {
                  $scope.AjaxLoading = false;
                  $scope.AttrList = data;
                  $scope.currentNavItem = 'page2';
                  $Product.ExistProduct = true;
                });
                $scope.loadAttr = () => {
                  $scope.attrLoading = true;
                  if (!$scope.AttrList) {
                    $Product.getAllAttr({ ProductID: node.ID }, data => {
                      $scope.AttrList = data;
                      $Product.ExistProduct = true;
                    });
                  }
                };

                //
                // $mdDialog.hide();
                // buildRoot()
              });
            }
          };
          $scope.saveAttrDefine = (AttrList, ExitAfterSave) => {
            if (ExitAfterSave) {
              $scope.AttrList.$saveAttr(data => {
                $mdDialog.hide();
                // buildRoot()
              });
            } else {
              $scope.AjaxLoading = true;
              $Product.saveAttr(
                AttrList,
                data => {
                  $scope.AjaxLoading = false;
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .position('top right')
                      .textContent('تغییرات با موفقیت ذخیره شد.')
                      .hideDelay(3000)
                      .parent($document.find('.md-dialog-container'))
                  );
                },
                err => {
                  $scope.AjaxLoading = false;
                }
              );
            }
          };
          $scope.cancel = function(Product) {
            $mdDialog.hide(Product);
          };
        }
      ],
      preserveScope: true,
      templateUrl: `${module_template_path}addNewProduct.html?cdv=${cdv}`,
      parent: angular.element(document.body),
      targetEvent: Element,
      clickOutsideToClose: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/product-info-header/product-info-header.controller.ts